<script setup>
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { onMounted, ref } from 'vue';
const { locale } = useI18n();
import { Head, Link, usePage } from '@inertiajs/vue3';
import { helperStore } from "@/store/helper"
// const helper = helperStore()
// const page = usePage()
// const testimonials = page.props.shared_data.testimonials_data

const testimonials = ref([]);

async function getAllTestimonial() {
    try {
        const res = await axios.get('/get-all-testimonials-data');
        testimonials.value = res.data || [];
    } catch (error) {
        console.error('Error fetching :', error);
    }
}

onMounted(() => {
    getAllTestimonial();
})

</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 xl:py-8 py-4 mx-auto">
            <div class="pb-10 wow animate__animated animate__fadeInLeft">
                <h2 class="text-center text-black leading-tight mx-auto font-roboto title-font xl:text-[44px] lg:text-[36px] sm:text-[28px] text-xl lg:mt-4 sm:mb-6 mb-4">{{$t("home.testimonial")}}</h2>
                <div class="mx-auto border-[3.5px] border-transparent border-t-[#1cbed1] w-36"></div>
            </div>
                <el-carousel  indicator-position="" arrow="hover" :interval="3000" height="420px">
                <el-carousel-item trigger="click" v-for="testimonial in testimonials" :key="testimonial.id">
                    <div class="flex flex-wrap bg-[#4BBFD1] wow animate__animated animate__fadeInLeft">
                    <div class="lg:w-1/2 mx-auto flex items-center justify-center">
                    <div class="lg:pl-16 pl-4 mx-auto">
                        <div class="text-white lg:pb-8 pb-4">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                    class="text-[#52CDDB] w-9 h-9 inline-block">
                                    <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z" class="w-9 h-9 text-[#52CDDB]">
                                    </path>
                                </svg>
                            </div>
                            <h2 class="title-font xl:text-[31px] lg:text-[25px] text-[21px] leading-tight lg:mb-4 mb-2 font-light text-white"
                            v-html="locale === 'BN' ? testimonial?.bn_content : testimonial?.content"></h2>
                            <p class="xl:text-xl text-lg font-medium text-white">{{ locale === 'BN' ? testimonial?.bn_title : testimonial?.title }}</p>
                        </div>
                    </div>
                </div>
                <div class="lg:w-1/2 md:w/2 mx-auto">
                    <div class="w-full lg:h-[420px] sm:h-[300px] h-[250px] mx-auto xl:py-10 sm:py-14 pb-14 lg:pr-16 pr-4 pl-4">
    
                        <!-- <video width="100%" height="100%" title="YouTube video player"
                            class="h-full w-full object-cover object-center border-[5px] rounded-3xl border-[#ffffff]"
                            frameborder="0"
                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            controls="">
                            <source src="/assets/images/nochinta.mp4" type="video/mp4">
                        </video> -->
                        <iframe
                        width="560"
                        height="315"
                        class="w-full h-full border-[5px] rounded-3xl border-white"
                        src="https://www.youtube.com/embed/kW7i56Ddxmc"
                        title="No chinta Video"
                        loading="lazy"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen>
                        </iframe>
                        
                    </div>
                </div>
            </div>
            </el-carousel-item>
            </el-carousel>
        </div>
    </section>
</template>
<style scoped></style>
